import React from "react";
import { industries } from "../mock";

export default function Marquee() {
  const row = [...industries, ...industries];
  return (
    <section className="py-10 border-y border-[var(--line)] bg-[var(--ink-2)] overflow-hidden">
      <div className="relative">
        <div className="marquee-track">
          {row.map((item, i) => (
            <div key={i} className="flex items-center flex-shrink-0">
              <span className="font-serif-display text-2xl sm:text-3xl italic text-[var(--ivory)]/85 px-8">
                {item}
              </span>
              <span className="text-[var(--gold)] text-xl">&bull;</span>
            </div>
          ))}
        </div>
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[var(--ink-2)] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[var(--ink-2)] to-transparent" />
      </div>
    </section>
  );
}
